import * as yup from 'yup';

export const topicSchema = yup.object().shape({
  title: yup
    .string()
    .required('Title cannot be emplty!')
    .max(2000, 'Title must not exceed 50 characters'),

  description: yup
    .string()
    .required('Description cannot be emplty!')
    .max(2000, 'Description must not exceed 200 characters'),
});

export const topicvalidation = async (comment) => {
  try {
    await topicSchema.validate(comment, { abortEarly: false });
    return {}; // No errors
  } catch (err) {
    return err.inner.reduce((acc, error) => {
      acc[error.path] = error.message;
      return acc;
    }, {});
  }
};
